export enum AlertType{
    Error,
    Warning
}
